/* eslint @stylistic/key-spacing: ["error", {  "align": "value" }]*/

const ROLES = {
    ADMINISTRATOR:                    'administrator',
    VIEW_ALL_TICKET_HOLDER_DATA:      'view-all-ticket-holder-data',
    CREATE_REPLACEMENT_TICKET:        'create-replacement-ticket',
    TERMINATE_TICKET:                 'terminate-ticket',
    DELETE_TICKET:                    'delete-ticket',
    CREATE_NEW_TICKET_HOLDER:         'create-new-ticket-holder',
    CREATE_NEW_ABO_TICKET:            'create-new-abo-ticket',
    EDIT_TICKET_HOLDERS:              'edit-ticket-holders',
    EDIT_TICKET_HOLDERS_EMAIL:        'edit-ticket-holders-email',
    SCHOOL_ACCOUNTING:                'school-accounting',
    USER_MANAGEMENT:                  'user-management',
    USER_ADMIN:                       'administrator',
    ACCESS_TICKET_HOLDERS:            'access-ticket-holders',
    ACCESS_SCHOOL_ASSIGNMENT_CHANGES: 'access-school-assignment-changes',
    ACCESS_APPLICATIONS:              'access-application-requests',
    ACCESS_SCHOOL:                    'access-school',
    ACCESS_CLASSES:                   'access-classes',
    ACCESS_ACCOUNTING:                'access-accounting',
    SCHEDULED_SCHOOL_CHANGE:          'scheduled-school-change',
    EDIT_TICKET_HOLDERS_COST_BEARER:  'edit-ticket-holders-cost-bearer'
}

export default ROLES